export default "__VITE_ASSET__636d58f5__"